import axios from "axios";

const data = {
  service_id: process.env.GATSBY_EMAILJS_SERVICE_ID,
  user_id: process.env.GATSBY_EMAILJS_USER_ID,
};

const contactTemplate = process.env.GATSBY_EMAILJS_TEMPLATE_CONTACT;
const bookingTemplate = process.env.GATSBY_EMAILJS_TEMPLATE_BOOK;

export const sendContactMessage = async (message) => {
  try {
    await axios.post(process.env.GATSBY_EMAILJS_POST_URL, {
      ...data,
      template_id: contactTemplate,
      template_params: message,
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const sendBookingRequest = async (message) => {
  try {
    await axios.post(process.env.GATSBY_EMAILJS_POST_URL, {
      ...data,
      template_id: bookingTemplate,
      template_params: message,
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};
